<template>
  <div class="my-pooq-content-body" data-scroll-element="true">
    <div class="my-graph-wrap" v-if="dataList">
      <!-- 상단 영역 -->
      <div class="analysis-title-box">
        <h3 class="analysis-title">많이 본 장르</h3>
        <div class="analysis-title-tab">
          <ul>
            <li>
              <button :class="tabType === 'vod' ? 'col-purple' : ''" @click.prevent="()=>callApi('vod')">VOD</button>
            </li>
            <li>
              <button :class="tabType === 'movie' ? 'col-purple' : ''" @click.prevent="()=>callApi('movie')">영화</button>
            </li>
          </ul>
        </div>
      </div>

      <!-- 그래프 영역 -->
      <div v-if="hasGraphData" class="my-graph">
        <p class="my-graph-tit"><span>{{pieTitle}}</span>장르를 많이 시청하셨네요.</p>

        <div class="my-graph-circle mypooq-chart-circle">
          <div id="donutchart">
            <vue-chart chart-type="PieChart" :columns="columns" :rows="pieData" :options="options"/>
          </div>
          <div class="runnung-time"><p>{{viewTime}}</p>시간</div>
        </div>

        <div class="my-graph-bar-wrap">

          <div :class="tabType === 'vod' ? 'my-graph-bar' : ''" v-for="(data, index) in dataList" :key="index">
            <p class="my-graph-bar-tit">
              <span class="my-graph-rank">{{index+1}}</span>{{data.title}}
              <span class="my-graph-percent">{{Math.floor(data.viewrate * 100)}}%</span>
            </p>
            <stacked-bar-chart :data="stackData[index]" :type="tabType"/>
            <div class="item-title-wrap">
              <div v-for="(item, itemIndex) in stackData[index]" class="item-title" :key="itemIndex + 'tabType'">
                <template>
                  <em :style="'background-color:' + item.color + ';'"></em>
                  <strong class="item-title-etc">{{ item.title }}</strong>
                </template>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div v-if="!hasGraphData" class="my-list-empty">
        <span class="ico-component-empty"><EmptyIcon /></span>
        <p v-if="tabType === 'vod'">이용한 VOD콘텐츠가 없어요.</p>
        <p v-else>이용한 영화콘텐츠가 없어요.</p>
        <p>지금 바로 시청해 보시는 건 어때요?</p>
        <a href="" class="my-empty-btn" @click.prevent="goHome">
          <span>홈으로 이동하기</span>
          <NextButtonGrey></NextButtonGrey>
        </a>
      </div>
    </div>
  </div>

</template>

<script>
import StackedBarChart from '@/components/lnb/mypooq/StackedBarChart'
import { MyPooqService } from '@/common/api/api.service'
import NextButtonGrey from '@/assets/svg/common/ic-next-s-g.svg'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import { get } from 'lodash'
export default {
  components: {
    StackedBarChart,
    NextButtonGrey,
    EmptyIcon
  },
  props: {
    device: {
      type: String
    }
  },
  data () {
    return {
      isNoData: false,
      viewTime: '',
      dataList: undefined,
      pieTitle: '',
      pieData: [],
      stackData: [],
      fontColor: [
        ['#1351f9', '#5986ff', '#90aeff', '#bfd0ff'],
        ['#00bbec', '#5cceec', '#94e8ff', '#e3f9ff'],
        ['#5532d3', '#7e65da', '#ac9fdd', '#e2dbfb']],
      tabType: 'vod',
      options: {
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.0,
        enableInteractivity: false,
        pieSliceBorderColor: 'none',
        backgroundColor: '#1b1b1b',
        slices: {
          0: { color: '#1351f9' },
          1: { color: '#00bbec' },
          2: { color: '#5532d3' },
          3: { color: '#a5a5a5' }
        },
        width: 500,
        height: 386,
        pieSliceTextStyle: { color: '#fff', fontSize: 14 },
        legend: { position: 'bottom', textStyle: { color: '#a5a5a5', fontSize: 12 } }
      },
      columns: [
        {
          type: 'string',
          label: 'title'
        },
        {
          type: 'number',
          label: 'percent'
        }
      ]
    }
  },
  methods: {
    // 현재 선택한 탭의 차트 데이터 API를 호출한다
    callApi (type) {
      this.tabType = type
      MyPooqService.analysisGraph({ type: type }).then((response) => {
        this.viewTime = get(response, 'data.viewtime', '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.dataList = get(response, 'data.analysisgraphlist', [])

        this.pieData = []
        this.stackData = [[], [], [], []]
        this.pieTitle = ''

        // 9999 초과시 9999+ 작업
        let viewTime = this.viewTime.replace(/,/, '')
        if (viewTime > 9999) {
          this.viewTime = '9,999+'
        }

        // 도넛그래프, 막대그래프 data.push
        for (let i = 0; i < this.dataList.length; i++) {
          if (i < 3) {
            this.pieTitle += this.dataList[i].title
            if (i + 1 < Math.min(this.dataList.length, 3)) {
              this.pieTitle += ', '
            }
          }

          this.pieData.push([this.dataList[i].title, this.dataList[i].viewrate * 100])

          for (let j = 0; j < this.dataList[i].sublist.length; j++) {
            this.stackData[i].push(
              {
                title: i === 3 ? 'etc.' : this.dataList[i].sublist[j].title,
                value: this.dataList[i].sublist[j].viewrate * 100,
                genre: this.dataList[i].sublist[j].parentsid,
                linkvalue: this.dataList[i].sublist[j].linkvalue,
                color: this.fontColor[i][j]
              }
            )
          }
        }
      })
    },
    goHome () {
      if (this.device === 'mobile') {
        this.$router.push('/')
      } else {
        location.href = 'captvpooq://index'
      }
    }
  },
  computed: {
    hasGraphData () {
      return this.dataList.length > 0
    }
  },
  created () {
    this.callApi('vod')
  }
}
</script>

<style lang="css">
  /* 취향분석 공통 */
  .component-line .analysis-title-box{
    border-bottom: 1px #2f2f2f solid;
  }

  .analysis-title-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 12px 16px 8px;
  }

  .analysis-title {
    position: relative;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
  }
  .analysis-title-tab ul{
    display: flex;
    flex-direction: row;
  }

  .analysis-title-tab li:first-child:after {
    content: "";
    display: inline-block;
    width: 1px;
    height: 10px;
    background-color: #a5a5a5;
    margin: 0 8px;
    vertical-align: middle;
  }

  .analysis-title-tab button {
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }

  .analysis-title-tab button.col-purple{
    color: #fff;
  }

  .analysis-title-tab button.my-btn-all {
    color: #23212a;
  }

  .analysis-title-tab button.my-btn-end {
    color: #1351f9;
  }

  /* 많이 본 장르 - 그래프 */
  .my-graph {
    padding: 40px 0 0;
  }

  .my-graph-tit {
    position: relative;
    z-index: 10;
    text-align: center;
    color: #a5a5a5;
    font-size: 20px;
    line-height: 29px;
  }

  .my-graph-tit > span {
    display: block;
    color: #fff;
  }

  .my-graph-bar-wrap {
    padding: 30px 20px;
  }

  .my-graph-bar {
    margin-bottom: 15px;
  }

  .my-graph-bar:last-child {
    margin-bottom: 0;
  }

  .my-graph-bar-tit {
    margin-bottom: 5px;
    font-size: 16px;
    color: #fff;
  }

  .my-graph-rank {
    font-size: 18px;
    margin-right: 5px;
    vertical-align: middle;
  }

  .my-graph-bar-tit:after {
    content: "";
    display: block;
    clear: both;
  }

  .my-graph-percent {
    float: right;
  }

  .my-graph-bar-tit a {
    font-size: 11px;
    color: #1351f9;
    margin-left: 4px;
  }

  .mypooq-chart-circle {
    width: 247px;
    height: 286px;
    position: relative;
    margin: 0 auto;
  }

  #donutchart {
    position: absolute;
    top: -74px;
    left: -125px;
    width: 500px;
    height: 386px;
  }

  .runnung-time {
    width: 102px;
    height: 102px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    margin-left: -51px;
    top: 50%;
    margin-top: -76px;
    box-shadow: 1px 2px 7px rgba(0, 0, 0, 0.2);
    text-align: center;
    color: #646464;
    font-size: 13px;
  }

  .runnung-time > p {
    font-weight: 700;
    font-size: 21px;
    color: #212121;
    padding-top: 35px;
  }

  .mypooq-chart-circle {
    margin: 30px auto 0;
  }

  .runnung-time {
    margin-left: -48px;
    margin-top: -72px;
  }

  .segbar {
    display: block;
    width: 100%;
    height: 8px
  }

  .segbar:after {
    content: "";
    display: block;
    clear: both;
  }

  .item-wrapper {
    float: left;
    height: 8px;
    position: relative
  }

  .item-wrapper:first-child {
    border-radius: 100px 0 0 100px;
  }

  .item-wrapper:last-child {
    border-radius: 0 100px 100px 0;
  }
  .item-wrapper:only-child {
    border-radius: 100px;
  }

  .item-title-wrap {
    width: 100%;
    text-align: center;
  }

  .item-title {
    display: inline-block;
    margin: 4px 8px 0;
    font-size: 0;
  }

  .item-title strong {
    display: inline-block;
    padding: 0 0 1px;
    border-bottom: 1px #a5a5a5 solid;
    font-family: 'NotoSans', sans-serif;
    font-size: 12px;
    color: #a5a5a5;
    font-weight: 400;
  }

  .item-title em {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
  }

  .my-graph-circle text{
    font-family: 'NotoSans', sans-serif;
  }
</style>
